<script>
export default {
  props: {
    booking: { type: Object, required: true },
    value: { type: Boolean, default: false },
  },
  data: () => ({
    fields: [
      {
        title: 'General Information',
        key: '',
        items: [
          { label: 'Booking ID', key: 'id' },
          { label: 'Booking status', key: 'status' },
          { label: 'Booked on', key: 'bookedOn' },
          { label: 'Stay period', key: 'stayPeriod' },
        ],
      },
      {
        title: 'Guest Information',
        key: 'guest',
        items: [
          { label: 'Title', key: 'title' },
          { label: 'First name', key: 'firstName' },
          { label: 'Last name', key: 'lastName' },
          { label: 'Email', key: 'email' },
        ],
      },
      {
        title: 'Payment',
        key: 'payment',
        items: [
          { label: 'Type', key: 'cardType' },
          { label: 'Number', key: 'cardNumber' },
          { label: 'Name on card', key: 'cardName' },
          { label: 'Exp', key: 'cardExpDate' },
        ],
      },
    ],
    transactionFields: [
      { label: 'Total', key: 'total' },
      { label: 'Discount', key: 'discount' },
      { label: 'Tax', key: 'tax' },
      { label: 'Service', key: 'service' },
      { label: 'Grand Total', key: 'grandTotal' },
    ],
  }),
  computed: {
    modalModel: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    getValue(childKey, key = null) {
      if (key) return this.booking[key][childKey]
      return this.booking[childKey]
    },
  },
}
</script>

<template>
  <BaseModal
    v-model="modalModel"
    size="2xl"
    :title="`Booking Details #${booking.id}`"
  >
    <template v-if="modalModel">
      <div v-for="field in fields" :key="field.key" class="mb-4">
        <h4 class="capitalize font-medium mb-2">{{ field.title }}</h4>
        <ul class="leading-none">
          <li
            v-for="fieldItem in field.items"
            :key="fieldItem.key"
            class="flex px-3 py-1"
          >
            <span class="w-1/3 sm:w-1/5">{{ fieldItem.label }}</span>
            <span class="w-2/3 sm:w-4/5">{{
              getValue(fieldItem.key, field.key)
            }}</span>
          </li>
        </ul>
      </div>

      <div class="mb-4">
        <h4 class="capitalize font-medium mb-2">Bookings</h4>
        <ul class="">
          <li
            v-for="room in booking.rooms"
            :key="room.id"
            class="flex justify-between px-3 py-1 border-b border-dotted mb-2"
          >
            <div class="flex justify-center">
              <div class="w-10 mr-2">{{ room.qty }} x</div>
              <div class="flex flex-col">
                <span>{{ room.name }} - {{ room.ratePlan }}</span>
                <span>{{ room.promotion }}</span>
              </div>
            </div>
            <span>
              <span class="mr-2">{{ room.price.currency }}</span>
              <span>{{ room.price.gross | currency }}</span>
            </span>
          </li>
        </ul>
        <ul class="">
          <li
            v-for="extra in booking.extras"
            :key="extra.id"
            class="flex justify-between px-3 py-1 border-b border-dotted mb-2"
          >
            <div class="flex justify-center">
              <div class="w-10 mr-2">{{ extra.qty }} x</div>
              <div class="flex flex-col">
                <span>{{ extra.name }}</span>
                <span>Preferred date: {{ extra.date }}@{{ extra.time }}</span>
              </div>
            </div>
            <span>
              <span class="mr-2">{{ extra.price.currency }}</span>
              <span>{{ extra.price.gross | currency }}</span>
            </span>
          </li>
        </ul>
      </div>

      <div class="mb-4">
        <h4 class="capitalize font-medium mb-2">Transactions</h4>
        <ul class="">
          <li
            v-for="field in transactionFields"
            :key="field.key"
            class="flex justify-between px-3 py-1 border-b border-dotted mb-2"
          >
            <span>{{ field.label }}</span>
            <span>
              <span class="mr-2">{{
                booking.transactionDetails.currency
              }}</span>
              <span>{{
                booking.transactionDetails[field.key] | currency
              }}</span>
            </span>
          </li>
        </ul>
      </div>
    </template>
  </BaseModal>
</template>
